import { useEffect, useMemo, useState } from "react";
import Listing from "../Api/Listing";
import Loading from "../components/Loading";
import NoData from "../components/NoData";
import toast from "react-hot-toast";
import AdminLayout from "../Layout/AdminLayout";

const ITEMS_PER_PAGE = 10;

function WidthrwalData() {
    const [loading, setLoading] = useState(false);
    const [listing, setListing] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [actionLoading, setActionLoading] = useState({
        id: "",
        type: "",
    });

    const filteredListing = useMemo(() => {
        const normalizedSearch = searchTerm.trim().toLowerCase();

        if (!normalizedSearch) {
            return listing;
        }

        return listing.filter((item) => {
            const username = item?.userId?.username || "";
            const upiId = item?.upi_id || "";
            const amount = item?.amount?.toString() || "";
            const paymentStatus = item?.payment_status === 0 ? "widthrawal" : item?.payment_status?.toString() || "";
            const withdrawalStatus = item?.payment_Wid_status || "";

            return [username, upiId, amount, paymentStatus, withdrawalStatus].some((value) =>
                value.toLowerCase().includes(normalizedSearch)
            );
        });
    }, [listing, searchTerm]);

    const fetchMarketList = async (page = 1) => {
        setLoading(true);
        try {
            const main = new Listing();
            const response = await main.WidthrawalList(page, ITEMS_PER_PAGE);
            const payload = response?.data || {};
            const items = Array.isArray(payload?.data) ? payload.data : [];
            const pagination = payload?.pagination || {};
            const totalCount = pagination?.totalRecords ?? items.length;
            const pageCount = pagination?.totalPages ?? Math.max(1, Math.ceil(totalCount / ITEMS_PER_PAGE));
            const serverPage = pagination?.currentPage ?? page;

            setListing(items);
            setCurrentPage(serverPage);
            setTotalItems(totalCount);
            setTotalPages(pageCount);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMarketList(1);
    }, []);

    const handleWithdrawalAction = async (id, type) => {
        if (!id) {
            toast.error("Withdrawal ID is required.");
            return;
        }

        const actionLabel = type === "approve" ? "approve" : "decline";
        const isConfirmed = window.confirm(`Are you sure you want to ${actionLabel} this withdrawal?`);

        if (!isConfirmed) {
            return;
        }

        setActionLoading({ id, type });
        try {
            const main = new Listing();
            const payload = { Id: id };
            const response =
                type === "approve"
                    ? await main.approveWithdrawal(payload)
                    : await main.declineWithdrawal(payload);

            if (response?.data?.status) {
                toast.success(response?.data?.message || `Withdrawal ${actionLabel}d successfully.`);
                fetchMarketList(currentPage);
            } else {
                toast.error(response?.data?.message || `Failed to ${actionLabel} withdrawal.`);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || `Unable to ${actionLabel} withdrawal.`);
        } finally {
            setActionLoading({ id: "", type: "" });
        }
    };

    const startEntry = totalItems === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1;
    const endEntry = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

    return (
        <AdminLayout>
            <div className="px-4 py-2 lg:px-10 lg:py-2.5">
                <div className="mt-8">
                    <div className="mb-4">
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by user name, UPI ID, amount"
                            className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring focus:ring-blue-200"
                        />
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white shadow-lg rounded-lg">
                            <thead>
                                <tr className="">
                                    <th className="py-3 px-3 text-center">#</th>
                                    <th className="py-3 px-3 text-center">User Name</th>
                                    <th className="py-3 px-3 text-center">UPI ID</th>
                                    <th className="py-3  px-3 text-center">Amount</th>
                                    <th className="py-3 px-3 text-center">Payment Status</th>
                                    <th className="py-3 px-3 text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 text-sm font-light">
                                {loading ? (
                                    <Loading />
                                ) : filteredListing.length === 0 ? (
                                    <NoData message={searchTerm ? "No matching withdrawals found on this page." : "No withdrawals found."} />
                                ) : (
                                    <>
                                        {filteredListing.map((item, index) => (
                                            <tr
                                                key={item?._id || index}
                                                className="border-b border-gray-200 hover:bg-gray-100"
                                            >
                                                <td className="py-3 px-3 text-center">
                                                    {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                                                </td>
                                                <td className="py-3 px-3 text-center">
                                                    {item?.userId?.username}
                                                </td>
                                                <td className="py-3 px-3 text-center">{item?.upi_id}</td>

                                                <td className="py-3 px-3 text-center">{item?.amount}</td>
                                                <td className="py-3 px-3 text-center">
                                                    {item?.payment_status === 0 && item?.payment_Wid_status === "inactive"
                                                        ? "Pending"
                                                        : item?.payment_Wid_status || "-"}
                                                </td>
                                                <td className="py-3 px-3 text-center">
                                                    {item?.payment_Wid_status === "inactive" ? (
                                                        <div className="flex items-center justify-center gap-2">
                                                            <button
                                                                type="button"
                                                                onClick={() => handleWithdrawalAction(item?._id, "approve")}
                                                                disabled={actionLoading.id === item?._id}
                                                                className="rounded-md bg-green-500 px-3 py-1 text-xs font-semibold text-white hover:bg-green-600"
                                                            >
                                                                {actionLoading.id === item?._id && actionLoading.type === "approve"
                                                                    ? "Approving..."
                                                                    : "Approved"}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleWithdrawalAction(item?._id, "decline")}
                                                                disabled={actionLoading.id === item?._id}
                                                                className="rounded-md bg-red-500 px-3 py-1 text-xs font-semibold text-white hover:bg-red-600"
                                                            >
                                                                {actionLoading.id === item?._id && actionLoading.type === "decline"
                                                                    ? "Declining..."
                                                                    : "Declined"}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <span className="capitalize text-sm font-medium text-gray-600">
                                                            {item?.payment_Wid_status || "-"}
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {!loading && filteredListing.length > 0 && (
                        <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                            <p className="text-sm text-gray-600">
                                {searchTerm
                                    ? `Showing ${filteredListing.length} matching withdrawals on page ${currentPage}`
                                    : `Showing ${startEntry} to ${endEntry} of ${totalItems} withdrawals`}
                            </p>

                            <div className="flex items-center gap-2">
                                <button
                                    type="button"
                                    onClick={() => fetchMarketList(Math.max(currentPage - 1, 1))}
                                    disabled={loading || currentPage === 1}
                                    className="rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    Previous
                                </button>

                                <span className="text-sm font-medium text-gray-700">
                                    Page {currentPage} of {totalPages}
                                </span>

                                <button
                                    type="button"
                                    onClick={() => fetchMarketList(Math.min(currentPage + 1, totalPages))}
                                    disabled={loading || currentPage === totalPages}
                                    className="rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </AdminLayout>
    );
}

export default WidthrwalData;